import StartPage from "./StartPage";
import TestPage from "./TestPage";
import ResultPage from "./ResultPage";
import RecommendPage from "./RecommendPage";
import FinalPage from "./FinalPage";
import MusicModal from "./MusicModal";
import InputPage from "./InputPage";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "../styles/App.scss";

const useAudio = (url) => {
    const [audio] = useState(new Audio(url));
    audio.loop = true; // Set the audio to loop
    const [playing, setPlaying] = useState(false);

    const toggle = () => setPlaying(!playing);

    useEffect(() => {
        playing ? audio.play() : audio.pause();
    }, [playing, audio]);

    useEffect(() => {
        audio.addEventListener("ended", () => setPlaying(false));
        return () => {
            audio.removeEventListener("ended", () => setPlaying(false));
        };
    }, [audio]);

    return [playing, toggle];
};

function PageWrapper() {
    // This component is a wrapper for the entire page. It includes the header, footer, and main content area.
    const [currentPage, setCurrentPage] = useState(0);
    const [testResults, setTestResults] = useState([
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
    ]);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [playing, toggle] = useAudio("./bg.mp3");
    const [show, setShow] = useState(true);

    const pages = [
        <StartPage
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            testResults={testResults}
            setTestResults={setTestResults}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
        />,
        <InputPage
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            testResults={testResults}
            setTestResults={setTestResults}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
        />,
        <TestPage
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            testResults={testResults}
            setTestResults={setTestResults}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
        />,
        <ResultPage
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            testResults={testResults}
            setTestResults={setTestResults}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
            
        />,
        <RecommendPage
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            testResults={testResults}
            setTestResults={setTestResults}
            currentQuestion={currentQuestion}
            setCurrentQuestion={setCurrentQuestion}
        />,
        <FinalPage />
    ];

    return (
            <AnimatePresence mode="popLayout">
                <img src={playing ? "/images/icon/volume-up-fill.svg" : "/images/icon/volume-mute-fill.svg"} alt="Music Icon" style={{position: 'absolute', width: '20px', height: '20px', right: '20px', top: '20px'}} onClick={toggle} />
                {show && <MusicModal setPlaying={toggle} setShow={setShow} />}
                <motion.div
                    key={currentPage + "-page"}
                    initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
            >
                {pages[currentPage]}
            </motion.div>
        </AnimatePresence>
    );
}

export default PageWrapper;
